import gql from 'graphql-tag';

// query the messages
const GET_INBOX_MESSAGES = gql`
  query FetchInboxMessages(
    $deviceId: String!
    $first: Int!
    $after: String
    $sort: InboxSortInput
  ) {
    viewer {
      inbox(deviceId: $deviceId, first: $first, after: $after, sort: $sort) {
        edges {
          node {
            id
            deliveredAt
            title
            subtitle
            isRead
            imageUrl
            link
          }
        }
        pageInfo {
          totalCount
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
      }
    }
  }
`;

export default GET_INBOX_MESSAGES;
